import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PostGraphneProductionPlanEntriesRequest, useGraphneAPI } from '@nexelem/graphne-api';
import { useCustomToast } from '@nexelem/snackbar';
import { useCustomTranslation } from '../hooks';
import { useLocation, useRevalidator } from 'react-router-dom';
import { taskDetailsQueryKey } from './productionPlanHooks/useGraphneTaskDetails';

type AddTaskToPlanMutationInput = {
  data: PostGraphneProductionPlanEntriesRequest;
  taskName: string;
};

export const useAddTaskToPlanMutation = () => {
  const api = useGraphneAPI();
  const displayToast = useCustomToast();
  const { tWrapper } = useCustomTranslation('products.productionPlan.addToPlanForm');
  const { pathname } = useLocation();
  const revalidator = useRevalidator();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data }: AddTaskToPlanMutationInput) => api.postGraphneProductionPlanEntries(data),
    onSuccess: async (_, { taskName, data }) => {
      await queryClient.invalidateQueries({ queryKey: taskDetailsQueryKey(data.taskAddEntry.taskId) });
      if (pathname.includes('graph')) {
        displayToast({
          toastType: 'successPermanent',
          message: tWrapper('successToastMessage', { taskName }),
          firstButton: {
            label: tWrapper('successButtonLabel'),
            onClick: revalidator.revalidate,
          },
        });
      } else {
        displayToast({
          toastType: 'success',
          message: tWrapper('successToastMessage', { taskName }),
        });
      }
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('errorToastMessage'),
      });
    },
  });
};
